import { Component, OnInit, Input } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ChatService } from 'src/app/providers/login-services/chat.service';
import { AngularFireDatabase } from 'angularfire2/database';
import { LocalStorageService } from 'ngx-store';

@Component({
  selector: 'app-games',
  templateUrl: './games.component.html',
  styleUrls: ['./games.component.css']
})
export class GamesComponent implements OnInit {
  @Input()
  code: string = '';
  urlSafe: SafeResourceUrl;
  pdfSelected;
  data;
  pdfList = [
    {
      src: 'https://vk.com/doc423424436_456080802?hash=bce6272097fab07260&dl=GQ4TONRUGAZTG:1513029425:2afd441301422ca043&api=1&no_preview=1',
      id:0,
      name:'sports'
    },
    {
      src: 'https://vk.com/doc423424436_456080802?hash=bce6272097fab07260&dl=GQ4TONRUGAZTG:1513029425:2afd441301422ca043&api=1&no_preview=1',
      id:1,
      name:'sports'
    }
  ];
  docRf;
  constructor(public sanitizer: DomSanitizer, public service:ChatService,
  private afd: AngularFireDatabase,
  private ls: LocalStorageService) { }

  ngOnInit() {
    let url = "https://vk.com/doc423424436_456080802?hash=bce6272097fab07260&dl=GQ4TONRUGAZTG:1513029425:2afd441301422ca043&api=1&no_preview=1";
    // this.urlSafe = url;
    // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    if ((this.ls.get("username") == "psm") || (this.ls.get("username") == "mad")) {
      this.docRf = this.afd.list("doc-dev");
    }
    this.getDoc();
  }

  activePDF(data){
    console.log({data})
    this.pdfSelected = data; 
  }

  getData() {
    this.service.getInstaFeed().subscribe( res=>{
      console.log('res', res);
    }, err =>{
      console.log('err', err);
      // console.log('err', JSON.stringify(err.error.text));
      // this.data = err.error.text;
    })
  }

  postDoc(v) {
    const data = (<HTMLInputElement>document.getElementById("code")).value;
    this.code = data;
    (<HTMLInputElement>document.getElementById("code")).value = "";
  }

  getDoc() {
    this.docRf.valueChanges().subscribe(res => {
      console.log(res);
      if(res) {
        this.pdfList = res[0];
      }
    });
  }

}



